import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-success-banner',
    templateUrl: './success-banner.component.html',
    standalone: false
})
export class SuccessBannerComponent {
  @Input() message: string = '';
}